<template>
  <a-form class="contact-group-form flex-grow-1 d-flex flex-column overflow-y-hidden p-20-px" :form="contactGroupForm" @submit="onSubmit">
    <div class="flex-grow-1">
      <a-row :gutter="20">
        <a-col :span="12">
          <a-form-item label="Contact Group Name" class="name">
            <a-input
              v-decorator="[
                'description',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input Contact Group Name!'
                    }
                  ]
                }
              ]"
              placeholder="Contact Group Name"
            >
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </div>
    <slot name="contacts"></slot>
    <div class="a-footer">
      <slot name="contacts-table-footer"></slot>
      <div class="mt-3">
        <a-button key="back" size="large" class="mr-3 slide-down-enter-active" @click="onCancel()">
          Cancel
        </a-button>
        <a-button key="submit" size="large" type="primary" html-type="submit" class="slide-down-enter-active">
          Save
        </a-button>
      </div>
    </div>
  </a-form>
</template>

<script>
  export default {
    name: 'ContactGroupForm',
    props: {
      description: {
        type: String,
        default: () => ''
      }
    },
    data() {
      return {
        groupId: this.$route.params.group
      };
    },
    watch: {
      description() {
        this.contactGroupForm.updateFields({
          description: this.$form.createFormField({
            ...this.description,
            value: this.description.value
          })
        });
      }
    },
    created() {
      this.contactGroupForm = this.$form.createForm(this, {
        name: 'contact-group-form',
        mapPropsToFields: () => {
          return {
            description: this.$form.createFormField({
              ...this.description,
              value: this.description
            })
          };
        }
      });
    },
    methods: {
      onSubmit(e) {
        e.preventDefault();
        this.contactGroupForm.validateFields((err, values) => {
          if (!err) {
            this.$emit('submit', values);
          }
        });
      },
      onCancel() {
        this.$router.push('/contact-group/list');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .a-body {
    padding: 20px;
  }
</style>
